<template>
  <div class="login" :style="loginBgStyle">
    <div class="login-logo">
      {{ platformTitle }}
      <!-- <img src="@/assets/img/login/LOGO.svg" alt="" /> -->
    </div>
    <div class="login-box">
      <div class="login-form">
        <div class="exam-title">欢迎回来</div>
        <div class="login-title">请登录你的教师账号</div>
        <el-form
          label-position="left"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="0px"
        >
          <div class="form-label">用户名</div>
          <el-form-item prop="username">
            <el-input
              type="text"
              v-model.trim="ruleForm.username"
              auto-complete="off"
              placeholder="请输入账号"
              size="large"
            >
              <template slot="prefix">
                <img
                  class="input-icon"
                  src="@/assets/img/login/user-teacher.png"
                  alt=""
                />
              </template>
            </el-input>
          </el-form-item>
          <div class="form-label">密码</div>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model.trim="ruleForm.password"
              auto-complete="off"
              placeholder="请输入密码"
              size="large"
              show-password
              @keyup.enter.native="handleSubmit"
            >
              <template slot="prefix">
                <img
                  class="input-icon"
                  src="@/assets/img/login/lock-teacher.png"
                  alt=""
                />
              </template>
            </el-input>
          </el-form-item>
          <div class="remember-row">
            <el-checkbox v-model="rememberMe">记住我</el-checkbox>
          </div>
          <el-form-item style="width: 100%;">
            <el-button
              round
              size="small"
              type="primary"
              class="confirm-btn"
              @click="handleSubmit"
              :loading="logining"
              >登 录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import settings from "@/settings";
import { getCookie, setCookie, delCookie } from "@/utils/util";
import { teacherAuthLogin } from "@/api/teacher/auth";
import { fetchAndSaveUserInfo, pickAccessToken } from "@/utils/userInfo";
import { setToken } from "@/utils/token";
import { loadDictCache } from "@/utils/dict";
import { fetchUserMenus } from "@/utils/dynamicMenu";
import { loadDynamicRoutes, getDefaultRoutePath } from "@/utils/dynamicRoutes";
import { loadUserPermissions } from "@/utils/permission";
import { TEACHER_DEFAULT_ROUTE } from "@/router/teacherStaticRoutes";

export default {
  name: "login",
  data() {
    return {
      logining: false,
      rememberMe: false,
      ruleForm: {
        username: "",
        password: ""
      },
      platformTitle: settings.title || "培训平台",
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  computed: {
    loginBgStyle() {
      return {
        backgroundImage: `url(${settings.loginBg})`
      };
    }
  },
  created() {
    this.restoreRemembered();
  },
  methods: {
    restoreRemembered() {
      const user = getCookie("teacher_user");
      const pwd = getCookie("teacher_pwd");
      if (user && pwd) {
        this.rememberMe = true;
        this.ruleForm.username = decodeURIComponent(user);
        this.ruleForm.password = decodeURIComponent(pwd);
      }
    },
    saveTeacherRemember(username, password, rememberMe) {
      if (rememberMe) {
        setCookie("teacher_user", encodeURIComponent(username), 30);
        setCookie("teacher_pwd", encodeURIComponent(password), 30);
      } else {
        delCookie("teacher_user");
        delCookie("teacher_pwd");
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.ruleForm.validate();
      } catch (e) {
        this.$message.error("请完善登录信息！");
        return;
      }
      await this.submitLogin({
        username: this.ruleForm.username,
        password: this.ruleForm.password,
        rememberMe: this.rememberMe
      });
    },
    async submitLogin({ username, password, rememberMe }) {
      if (this.logining) return;
      this.logining = true;
      try {
        const result = await teacherAuthLogin({
          account: username,
          password
        });
        this.saveTeacherRemember(username, password, rememberMe);

        const token = pickAccessToken(result.data || result);
        if (!token) {
          this.$message.error((result && result.msg) || "登录成功但未返回令牌");
          return;
        }
        setToken(token);

        const userInfo = await fetchAndSaveUserInfo();
        await loadDictCache().catch(() => {});
        await loadUserPermissions(this);
        await loadDynamicRoutes();
        await fetchUserMenus({ force: true });
        this.$store.commit("login", userInfo);
        this.$root.Bus.$emit("user-info-updated");
        const target =
          TEACHER_DEFAULT_ROUTE || getDefaultRoutePath() || "/home";
        this.$router.replace({ path: target }).catch(() => {});
      } catch (e) {
        // interceptor
      } finally {
        this.logining = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  height: 100%;
  background-color: #f5f7fa;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  .login-logo {
    width: 700px;
    margin-right: 100px;
  }
  .login-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 50%;
  }
  .login-form {
    padding: 32px;
    border-radius: 24px;
    width: 320px;
    background-color: #fff;
  }
  .exam-title {
    text-align: center;
    color: #1e4d8a;
    font-weight: bold;
    font-size: 20px;
    line-height: 36px;
    font-family: "Source Han Sans Bold" !important;
  }
  .login-logo {
    position: fixed;
    top: 80px;
    left: 80px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 18px;
    font-size: 42px;
    color: #1e3a8a;
    font-weight: bold;
    img {
      height: 60px;
    }
  }
  .login-title {
    text-align: center;
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 28px;
    color: #6b8ba8;
  }
  .form-label {
    font-weight: bold;
    font-size: 14px;
    color: #4e789a;
    line-height: 32px;
  }
  .remember-row {
    margin: -6px 0 16px;
    /deep/ .el-checkbox__label {
      color: #6b8ba8;
      font-size: 14px;
      font-weight: bold;
    }
  }
  /deep/ .el-input {
    width: 100%;
  }
  /deep/ .input-icon {
    width: 16px;
    height: 16px;
    margin-top: 15px;
    margin-left: 6px;
  }
  /deep/ .el-input__inner {
    box-shadow: none;
    padding-left: 36px;
    border: 1px solid rgba(59, 161, 255, 0.18);
    height: 46px;
    border-radius: 14px;
  }

  .confirm-btn {
    color: #fff;
    width: 100%;
    box-shadow: 0px 4px 18px 0px rgba(59, 161, 255, 0.38);
    background: linear-gradient(153deg, #3ba1ff 0%, #637ef1 100%);
    height: 46px;
    border-radius: 14px;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue